export default __webpack_public_path__ + "static/media/errorImg.75ccd3fe.svg";